import Pagination from './src/pagination.jsx';

/* istanbul ignore next */
Pagination.install = function(Vue) {
  Vue.component(Pagination.name, Pagination);
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/packages/pagination/index.js